import { useEffect, useState } from 'react';
import { useGetWarrantyClaimsListByChassisQuery } from '../../../../api/endpoints/warrantyClaims';

const useChassisInfoData = (chassisNo) => {
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    useEffect(() => {
        setPageNumber(1);
    }, [chassisNo]);

    const { data, isFetching } = useGetWarrantyClaimsListByChassisQuery({ ChassisNo: chassisNo, PageNumber: pageNumber, PageSize: pageSize }, { skip: !chassisNo });

    const onPage = (event) => {
        setPageNumber(event.page + 1);
        setPageSize(event.rows);
    };

    return {
        items: data?.data?.items ?? [],
        totalRecords: data?.data?.totalCount ?? 0,
        loading: isFetching,
        first: (pageNumber - 1) * pageSize,
        rows: pageSize,
        onPage
    };
};

export default useChassisInfoData;
